import React from 'react'
import { 
  Redirect,
  Link
} from 'react-router-dom'
import { connect } from 'react-redux'
 
import { actions as authActions } from '@modules/auth'
import LayoutCentered from '@components/LayoutCentered/LayoutCentered'
import BrandLogo from '@components/BrandLogo/BrandLogo'


import './Login.scss'
 
// TODO: add prop types
// TODO: use react-form to do the forms
function mapStateToProps(state) {
  const { loggingIn, loggedIn, loginMessage } = state.auth;
  return {
    loggingIn,
    loggedIn,
    loginMessage,
  };
}

@LayoutCentered
@connect(mapStateToProps)
class Login extends React.Component {
  constructor(props) {
    super(props);

    // ensure user is logged out if client thinks they are
    // TODO: put this back in if it turns out to be useful
    // !authService.isAuthenticated() && this.props.dispatch(authActions.logout(this.props.loginMessage));

    // TODO: make this cleaner.. es7 optional chaining babel?
    var pathname = props.location
      && props.location.state
      && props.location.state.from
      && props.location.state.from.pathname;

    this.state = {
      email: '',
      password: '',
      submitted: false,
      redirectTo: (pathname !== '/logout' && pathname) || '/dashboard',
      message: props.message ? props.message : false,
    }
 
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
 
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }
 
  handleSubmit(e) {
    e.preventDefault();
    console.log(this);
 
    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;
    if (email && password) {
      dispatch(authActions.login(email, password));
    }
  }
 
  render() {
    const { loggingIn, loggedIn, loginMessage } = this.props;
    const { email, password, submitted } = this.state;
    // TODO: cleanup html!
    return (
      <div className="LoginPage">
        
        { 
          // redirect 
          loggedIn && <Redirect to={this.state.redirectTo} /> }
        <BrandLogo />
        <h1>Login</h1>
        <form className="LoginForm" name="form" onSubmit={::this.handleSubmit}>
          <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
            <label htmlFor="email">Email Address</label>
            <input 
              type="text" 
              className="form-control" 
              name="email" value={email} 
              onChange={this.handleChange} 
              autoComplete="section-login username"
            />
            {submitted && !email &&
              <div className="help-block">Email Address is required</div>
            }
          </div>
          <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              className="form-control" 
              name="password" 
              value={password} 
              onChange={this.handleChange} 
              autoComplete='section-login password'
            />
            {submitted && !password &&
              <div className="help-block">Password is required</div>
            }
          </div>
          <div className="form-group">
            <div>
              <p>Not registered? <Link to="/register">register</Link></p>
              <p><Link to="/forgot-password">forgot password?</Link></p>
            </div>
            <button className="btn btn-primary">Sign in</button>
            {loggingIn &&
              <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }
          </div>
        </form>

        { loginMessage && <div className="LoginForm-message">{loginMessage}</div> }
      </div>
    );
  }
}
 
export default Login;


// WEBPACK FOOTER //
// ./src/scenes/Login/Login.jsx